import { Box } from '@mui/material';
import { EmbeddedCheckout, EmbeddedCheckoutProvider } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useEffect, useMemo, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import fetch from '../../fetch';
import sanity from '../../sanity';
//const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
import { expressCountries } from '../../constants/express';
import countryService from 'iso-country-currency';
import NavMobile from '../Nav/NavMobile';
import NavDesktop from '../Nav/NavDesktop';

const mapStateToProps = (state) => {
    return {
        user: state.user.currentUser,
        company: state.common.company,
        connected_account: state.common.connected_account,
        connected_products: state.common.connected_products,
        connected_prices: state.prices.connected_prices
    };
};

// const mapDispatchToProps = (dispatch) => ({
//     onLoad: (payload) => dispatch({ type: EVENT_LIST_PAGE_LOADED, payload }),
//     onPriceChange: (payload) => dispatch({ type: CONNECT_PRICE_CHANGE, payload })
// });

const CheckOut = (props) => {
    const { id } = useParams();
    const [event, setEvent] = useState();
    const [loading, setLoading] = useState(false);
    const [isPortrait, setIsPortrait] = useState(false);
    const [product, setProduct] = useState();
    const [price, setPrice] = useState();
    const [options, setOptions] = useState();
    const { user, connected_account } = props;

    const stripePromise = useMemo(() => {
        if (connected_account?.accountId) {
            return loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY, {
                // stripeAccount: connected_account?.accountId
            });
        }
    }, [connected_account]);

    // useEffect(() => {
    //     const fetchData = async () => {
    //         try {
    //             const promise = await loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY, {
    //                 stripeAccount: connected_account.accountId
    //             });
    //             setStripePromise(promise);
    //         } catch (error) {
    //             console.log('ERROR: ', error);
    //         } finally {
    //             //
    //         }
    //     };
    //     if (connected_account) {
    //         fetchData();
    //     }
    // }, [connected_account]);

    // console.log('STRIPE OPTIONS1: ', stripePromise);
    // console.log('OPTIONS1 :', options);

    useEffect(() => {
        const fetchEvent = async () => {
            try {
                setLoading(true);
                const event = await sanity.Events.GetEventById(id);
                setEvent(event);
            } catch (error) {
                console.log('ERROR:', error);
            } finally {
                setLoading(false);
            }
        };
        if (id) {
            fetchEvent();
        }
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                console.log('event: ', event.pay_per_view_product);
                const product = await fetch.Products.Get(undefined, event.pay_per_view_product);
                setPrice(product.default_price);
                setProduct(product);
            } catch (error) {
                console.log('ERROR: ', error);
            } finally {
                //
            }
        };
        if (event && props?.connected_account) {
            fetchData();
        }
    }, [event, connected_account]);

    useEffect(() => {
        const fetchClientSecret = async () => {
            if (!connected_account || !price || !product || !user) return;
            const line_item = [
                {
                    price: price.id,
                    quantity: 1
                }
            ];
            const metadata = {
                companyId: connected_account?.companyId,
                eventId: event.id,
                priceId: price.id,
                productId: product.id,
                customer_email: user?.data?.email
            };
            let currency = '';
            countryService
                .getAllISOCodes()
                .filter((c) => expressCountries.some((v) => v.iso === c.iso))
                .map((t) => {
                    if (t.iso === props?.connected_account?.country) currency = t.currency;
                });

            // Create a Checkout Session
            console.log('line item: ', line_item);
            console.log('metadata', metadata);
            console.log('currency: ', currency);
            console.log(' connected_account.accountId', connected_account.accountId);
            return fetch.Checkout.Create(
                line_item,
                currency,
                `${window.location.origin}/watch/${event.id}`,
                user?.data?.email,
                connected_account.accountId,
                'acct_1N1nKJEQDnupCweN',
                metadata
            ).then((data) => {
                console.info('data.client_secret======> ', data.client_secret);
                setOptions(data.client_secret);
                return data.client_secret;
            });
        };
        if (connected_account && price && product && user) {
            fetchClientSecret();
        }
    }, [connected_account, price, product, user]);

    return (
        <Box>
            {isMobile ? <NavMobile /> : <NavDesktop />}

            <Box sx={{ padding: isMobile ? '1rem 1rem 0 1rem' : '1rem 3rem 0rem' }}>
                {stripePromise && options && (
                    <EmbeddedCheckoutProvider
                        stripe={stripePromise}
                        options={{ clientSecret: options }}>
                        <EmbeddedCheckout />
                    </EmbeddedCheckoutProvider>
                )}
            </Box>
        </Box>
    );
};

export default connect(mapStateToProps, null)(CheckOut);
